/* cp-tt — controller for the TrailTag personalisation buybox.

   Everything the page needs is in the JSON config the section prints, so this
   never fetches to render: design art, plate colours, overlay coordinates,
   prices and the copy strings all arrive with the document.

   Preview typography is written as custom properties on the root element
   rather than as inline styles on each span, because the same engraving is
   drawn in four places (stage front, stage back, flat front, flat back) and
   one write should move all of them. */

(function () {
  'use strict';

  /* Shopify money formats come in four shapes. Anything unrecognised falls
     back to the amount with two decimals, which is wrong-looking rather than
     broken. */
  function formatMoney(cents, format) {
    var value = (Number(cents) || 0) / 100;

    function withDelimiters(num, precision, thousands, decimal) {
      var fixed = num.toFixed(precision);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    }

    var match = /\{\{\s*(\w+)\s*\}\}/.exec(format || '');
    if (!match) return withDelimiters(value, 2, ',', '.');

    var body;
    switch (match[1]) {
      case 'amount_no_decimals':
        body = withDelimiters(value, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        body = withDelimiters(value, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        body = withDelimiters(value, 0, '.', ',');
        break;
      default:
        body = withDelimiters(value, 2, ',', '.');
    }
    return format.replace(match[0], body);
  }

  function round1(n) {
    return Math.round(n * 10) / 10;
  }

  var Buybox = {
    init: function (root) {
      if (!root || root.dataset.ttReady === '1') return;

      var configEl = root.querySelector('[data-cp-tt="config"]');
      if (!configEl) return;

      var config;
      try {
        config = JSON.parse(configEl.textContent);
      } catch (e) {
        /* A malformed config leaves the markup standing and the no-JS select
           usable, which is better than a half-wired picker. */
        return;
      }
      if (!config.designs || !config.designs.length) return;

      root.dataset.ttReady = '1';

      var q = function (name) {
        return root.querySelector('[data-cp-tt="' + name + '"]');
      };
      var qa = function (name) {
        return Array.prototype.slice.call(root.querySelectorAll('[data-cp-tt="' + name + '"]'));
      };

      var el = {
        form: root.querySelector('form'),
        variantId: q('variant-id'),
        propDesign: q('prop-design'),
        propFont: q('prop-font'),
        name: q('name'),
        nameCount: q('name-count'),
        back: q('back'),
        backCount: q('back-count'),
        backwrap: q('backwrap'),
        priceNow: q('price-now'),
        priceWas: q('price-was'),
        priceSave: q('price-save'),
        totalNow: q('total-now'),
        totalWas: q('total-was'),
        totalSave: q('total-save'),
        cta: q('cta'),
        ctaLabel: q('cta-label'),
        ctaHint: q('cta-hint'),
        error: q('error'),
        thumbFront: q('thumb-front'),
        designImg: q('design-img'),
        designThumb: q('design-thumb'),
        sticky: q('sticky'),
        stickyImg: q('sticky-img'),
        stickyPrice: q('sticky-price'),
        stickyBtn: q('sticky-btn'),

        /* The engraving preview is drawn twice — once on the gallery stage and
           once inside step 3 — and the design label three times. These are
           collections, not single nodes, so every copy moves together. */
        designLabels: qa('design-label'),
        liveFronts: qa('live-front'),
        frontBoxes: qa('front-box'),
        frontTexts: qa('front-text'),
        backTexts: qa('back-text')
      };

      var state = {
        design: config.designs[0],
        font: (config.fonts && config.fonts[0]) || null,
        name: '',
        backText: '',
        bothSides: true
      };

      /* Open on whichever design the markup rendered as checked, so a
         ?variant= deep link and the JS agree from the first paint. */
      var checkedDesign = root.querySelector('[data-cp-tt="design"]:checked');
      if (checkedDesign) {
        config.designs.forEach(function (d) {
          if (d.value === checkedDesign.value) state.design = d;
        });
      }
      var checkedFont = root.querySelector('[data-cp-tt="font"]:checked');
      if (checkedFont && config.fonts) {
        config.fonts.forEach(function (f) {
          if (f.label === checkedFont.value) state.font = f;
        });
      }

      /* ---- rendering ---- */

      function renderDesign() {
        var d = state.design;

        el.liveFronts.forEach(function (img) {
          if (d.live) img.src = d.live;
          if (d.alt) img.alt = d.alt;
        });
        if (el.thumbFront && d.live) el.thumbFront.src = d.live;

        /* The design pane is what the stage shows until a name is typed, so it
           has to follow the selection or a design change looks like it did
           nothing. */
        if (el.designImg && d.tile) {
          el.designImg.src = d.tile;
          if (d.alt) el.designImg.alt = d.alt;
        }
        if (el.designThumb && d.tile) el.designThumb.src = d.tile;
        if (el.stickyImg && d.tile) el.stickyImg.src = d.tile;

        /* Each design's plate sits in a different place in its own photo, so
           the overlay box moves with the design rather than being fixed. */
        if (d.box) {
          el.frontBoxes.forEach(function (box) {
            box.style.left = d.box.l;
            box.style.top = d.box.t;
            box.style.width = d.box.w;
            box.style.height = d.box.h;
          });
        }

        el.designLabels.forEach(function (node) {
          node.textContent = d.label;
        });
        if (el.propDesign) el.propDesign.value = d.label;
        if (el.variantId && d.variantId) el.variantId.value = d.variantId;

        renderPrice();
      }

      function renderPrice() {
        var d = state.design;
        var now = formatMoney(d.price, config.moneyFormat);
        if (el.priceNow) el.priceNow.textContent = now;
        if (el.totalNow) el.totalNow.textContent = now;
        if (el.stickyPrice) el.stickyPrice.textContent = now;

        var hasSaving = Number(d.compareAt) > Number(d.price);
        var was = hasSaving ? formatMoney(d.compareAt, config.moneyFormat) : '';

        [el.priceWas, el.totalWas].forEach(function (node) {
          if (!node) return;
          node.textContent = was;
          node.hidden = !hasSaving;
        });

        /* Two saving badges: one by the headline price, one above the button.
           Both carry the same wording, so they are filled from one place. */
        var saveText = '';
        if (hasSaving) {
          var diff = Number(d.compareAt) - Number(d.price);
          /* The percent carries its own sign, matching the cp-bp, cp-rc and
             cp-wp controllers — their templates read ({percent}). */
          var percent = Math.round((diff / Number(d.compareAt)) * 100) + '%';
          saveText = (config.strings.saveTemplate || '')
            .replace('{amount}', formatMoney(diff, config.moneyFormat))
            .replace('{percent}', percent);
        }
        [el.priceSave, el.totalSave].forEach(function (node) {
          if (!node) return;
          node.textContent = saveText;
          node.hidden = !hasSaving;
        });
      }

      function renderFont() {
        var f = state.font;
        if (!f) return;
        root.style.setProperty('--tt-family', f.family);
        root.style.setProperty('--tt-weight', f.weight);
        root.style.setProperty('--tt-style', f.style);
        root.style.setProperty('--tt-spacing', f.spacing);
        if (el.propFont) el.propFont.value = f.label;
        renderName();
      }

      function renderName() {
        var d = state.design;
        var f = state.font;
        var scale = (f && Number(f.scale)) || 1;
        var text = state.name;
        var len = Math.max(text.length, 3);

        el.frontTexts.forEach(function (node) {
          node.textContent = text;
        });

        /* The overlay sits in a box sized per design, so the name is scaled
           against that design's own numbers. */
        var overlay = Math.min(Number(d.cap) || 26, round1((Number(d.div) || 126) / len));
        root.style.setProperty('--tt-front-size', round1(overlay * scale) + 'cqi');

        renderCta();
      }

      function renderBack() {
        var show = state.bothSides;
        var text = show ? state.backText : '';
        var blank = config.strings.blankBack || 'Left blank';

        el.backTexts.forEach(function (node) {
          node.textContent = show ? text : blank;
        });

        /* The back carries free text that wraps, so it steps down through a
           few sizes as it fills rather than scaling per character. */
        var load = text.length;
        var photo = load > 92 ? 7 : load > 68 ? 8 : load > 44 ? 9.5 : 11;
        root.style.setProperty('--tt-back-size', photo + 'cqi');

        if (el.backCount) el.backCount.textContent = load + '/' + config.backMax;
      }

      function renderCta() {
        if (!el.cta) return;
        var ready = state.name.trim().length > 0;
        var available = state.design.available !== false;

        if (el.stickyBtn) {
          el.stickyBtn.dataset.state = !available ? 'soldout' : ready ? 'ready' : 'blocked';
          el.stickyBtn.textContent = !available
            ? config.strings.ctaSoldOut
            : ready
              ? config.strings.stickyReady || 'Add to cart'
              : config.strings.stickyBlocked || 'Personalise';
        }

        if (!available) {
          el.cta.dataset.state = 'soldout';
          el.cta.setAttribute('aria-disabled', 'true');
          if (el.ctaLabel) el.ctaLabel.textContent = config.strings.ctaSoldOut;
          return;
        }

        el.cta.dataset.state = ready ? 'ready' : 'blocked';
        el.cta.setAttribute('aria-disabled', ready ? 'false' : 'true');

        if (el.ctaLabel) {
          el.ctaLabel.textContent = ready
            ? (config.strings.ctaReady || '').replace(
                '{amount}',
                formatMoney(state.design.price, config.moneyFormat)
              )
            : config.strings.ctaBlocked;
        }
        if (el.ctaHint) {
          el.ctaHint.dataset.state = ready ? 'ok' : 'empty';
          el.ctaHint.textContent = ready ? config.strings.hintOk : config.strings.hintEmpty;
        }
      }

      /* ---- wiring ---- */

      qa('design').forEach(function (input) {
        input.addEventListener('change', function () {
          config.designs.forEach(function (d) {
            if (d.value === input.value) state.design = d;
          });
          renderDesign();
          renderName();
          showSelectedDesign();
        });
        /* Clicking the design that is already selected fires no change event,
           but it is still the shopper choosing it — the default design has to
           be revealable too. */
        input.addEventListener('click', function () {
          if (input.checked) showSelectedDesign();
        });
      });

      qa('font').forEach(function (input) {
        input.addEventListener('change', function () {
          (config.fonts || []).forEach(function (f) {
            if (f.label === input.value) state.font = f;
          });
          renderFont();
        });
      });

      if (el.name) {
        el.name.addEventListener('input', function () {
          /* Only characters the printer can set. Stripping here rather than on
             submit means the preview never shows a character that will not be
             printed. */
          var clean = el.name.value.normalize('NFC').replace(/[^À-ÖØ-öø-ſa-zA-Z0-9 '.-]/g, '').slice(0, config.nameMax);
          if (clean !== el.name.value) el.name.value = clean;
          state.name = clean;
          if (el.nameCount) el.nameCount.textContent = clean.length + '/' + config.nameMax;
          if (el.error) el.error.textContent = '';
          renderName();
          syncLiveThumb();
        });
      }

      if (el.back) {
        el.back.addEventListener('input', function () {
          state.backText = el.back.value.slice(0, config.backMax);
          renderBack();
        });
      }

      qa('side').forEach(function (input) {
        input.addEventListener('change', function () {
          state.bothSides = input.value === 'both';
          if (el.backwrap) el.backwrap.hidden = !state.bothSides;
          /* Disabled controls are not submitted, so switching to front-only
             drops the property outright rather than sending an empty one. */
          if (el.back) el.back.disabled = !state.bothSides;
          renderBack();
        });
      });

      /* ---- gallery ---- */

      var panes = {
        live: q('pane-live'),
        design: q('pane-design'),
        media: qa('pane-media')
      };
      var thumbs = qa('thumb');
      var liveThumb = null;
      var designThumbBtn = null;
      var firstMediaThumb = null;
      thumbs.forEach(function (button) {
        var t = button.dataset.target;
        if (t === 'live') liveThumb = button;
        else if (t === 'design') designThumbBtn = button;
        else if (!firstMediaThumb) firstMediaThumb = button;
      });
      var liveRevealed = false;

      function showPane(target) {
        if (panes.live) panes.live.hidden = target !== 'live';
        if (panes.design) panes.design.hidden = target !== 'design';
        panes.media.forEach(function (pane) {
          var match = pane.dataset.index === target;
          pane.hidden = !match;
          var video = pane.querySelector('video');
          if (!video) return;
          if (match) {
            /* Product videos play as soon as their pane is shown. Muted is set
               in script as well as markup because some browsers ignore the
               attribute once a video has been touched, and an unmuted play()
               without a tap is refused outright. The catch swallows that
               refusal — the controls are still there to press play. */
            video.muted = true;
            var played = video.play();
            if (played && played.catch) played.catch(function () {});
          } else if (!video.paused) {
            /* Leaving a pane should stop its sound, not just hide it. */
            video.pause();
          }
        });
      }

      /* After a design change the stage shows that design: the live engraving
         if there is a name to engrave, otherwise the design's own photo. The
         design thumbnail is hidden on load and only joins the rail here, once
         the shopper has actually chosen something. */
      function showSelectedDesign() {
        if (designThumbBtn) designThumbBtn.hidden = false;
        var target = state.name.trim() && liveThumb && !liveThumb.hidden ? liveThumb : designThumbBtn;
        if (!target) return;
        setActiveThumb(target);
        showPane(target.dataset.target);
      }

      function setActiveThumb(button) {
        thumbs.forEach(function (other) {
          other.classList.toggle('is-active', other === button);
          other.setAttribute('aria-pressed', other === button ? 'true' : 'false');
        });
      }

      thumbs.forEach(function (button) {
        button.addEventListener('click', function () {
          setActiveThumb(button);
          showPane(button.dataset.target);
        });
      });

      /* The engraving thumbnail earns its place only once there is something
         engraved on it — before that it is a picture of a blank tag sitting in
         front of the real product shots. It appears on the first character
         typed, takes the stage once so the shopper sees their name land, and
         disappears again if they clear the field. */
      function syncLiveThumb() {
        if (!liveThumb) return;
        var wanted = state.name.trim().length > 0;

        if (wanted && liveThumb.hidden) {
          liveThumb.hidden = false;
          if (!liveRevealed) {
            liveRevealed = true;
            setActiveThumb(liveThumb);
            showPane('live');
          }
        } else if (!wanted && !liveThumb.hidden) {
          var wasActive = liveThumb.classList.contains('is-active');
          liveThumb.hidden = true;
          liveRevealed = false;
          /* Never leave the stage on a pane whose thumbnail just vanished —
             fall back to the chosen design's photo if one has been picked,
             otherwise to the first product image. */
          var fallback = designThumbBtn && !designThumbBtn.hidden ? designThumbBtn : firstMediaThumb || designThumbBtn;
          if (wasActive && fallback) {
            fallback.hidden = false;
            setActiveThumb(fallback);
            showPane(fallback.dataset.target);
          }
        }
      }

      /* ---- swipe between gallery panes ---- */

      /* On a phone the stage is the natural thing to swipe, and the rail
         below it scrolls sideways on its own — so a horizontal swipe on the
         stage steps to the neighbouring visible thumbnail, exactly as a tap on
         that thumbnail would. Vertical drags are left to the page. */
      var stage = root.querySelector('.cp-tt-stage');
      if (stage) {
        var sx = 0;
        var sy = 0;
        var tracking = false;
        stage.addEventListener('touchstart', function (event) {
          if (event.touches.length !== 1) return;
          /* A drag that starts on the video controls belongs to the scrubber. */
          if (event.target.closest && event.target.closest('video')) return;
          tracking = true;
          sx = event.touches[0].clientX;
          sy = event.touches[0].clientY;
        }, { passive: true });
        stage.addEventListener('touchend', function (event) {
          if (!tracking) return;
          tracking = false;
          var t = event.changedTouches[0];
          var dx = t.clientX - sx;
          var dy = t.clientY - sy;
          if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.3) return;
          var visible = thumbs.filter(function (b) { return !b.hidden; });
          var at = visible.findIndex(function (b) { return b.classList.contains('is-active'); });
          var next = visible[at + (dx < 0 ? 1 : -1)];
          if (!next) return;
          setActiveThumb(next);
          showPane(next.dataset.target);
          /* Keep the active thumbnail in view without moving the page. */
          var rail = next.parentElement;
          if (rail) {
            rail.scrollTo({ left: next.offsetLeft - (rail.clientWidth - next.offsetWidth) / 2, behavior: 'smooth' });
          }
        }, { passive: true });
      }

      /* ---- mobile sticky bar ---- */

      /* Shown only once the shopper has scrolled past the form — never while
         any of it is on screen, so it cannot sit over a field they are typing
         into, and not above it either, where the buybox is still coming up. */
      if (el.sticky && el.form && 'IntersectionObserver' in window) {
        var formVisible = true;
        var setSticky = function () {
          var past = el.form.getBoundingClientRect().bottom < 0;
          var show = !formVisible && past;
          el.sticky.classList.toggle('is-shown', show);
          document.documentElement.classList.toggle('cp-tt-sticky-on', show);
        };
        new IntersectionObserver(function (entries) {
          formVisible = entries[0].isIntersecting;
          setSticky();
        }).observe(el.form);
        window.addEventListener('scroll', function () {
          if (!formVisible) setSticky();
        }, { passive: true });

        if (el.stickyBtn) {
          el.stickyBtn.addEventListener('click', function () {
            if (state.design.available === false) return;
            if (state.name.trim() && el.cta) {
              /* The real submit button, so the form's own checks and the
                 theme's cart handling run exactly as for a direct tap. */
              el.cta.click();
              return;
            }
            if (el.name) {
              el.name.scrollIntoView({ block: 'center', behavior: 'smooth' });
              /* preventScroll so focusing does not fight the smooth scroll. */
              el.name.focus({ preventScroll: true });
            }
          });
        }
      }

      /* ---- submit ---- */

      /* On the button, not the form: Horizon's submit handler runs first, in the
         capture phase, and would post the form whatever a submit listener says. */
      if (el.cta) {
        el.cta.addEventListener('click', function (event) {
          if (state.design.available === false) {
            event.preventDefault();
            return;
          }
          if (!state.name.trim()) {
            /* The button stays a button in the blocked state, so the click has
               to say why rather than doing nothing. */
            event.preventDefault();
            if (el.error) el.error.textContent = config.strings.hintEmpty;
            if (el.name) {
              el.name.focus();
              el.name.scrollIntoView({ block: 'center', behavior: 'smooth' });
            }
          }
        });
      }

      renderDesign();
      renderFont();
      renderName();
      renderBack();
      /* A browser-restored name after a back-navigation counts as typed. */
      if (el.name && el.name.value) {
        state.name = el.name.value;
        if (el.nameCount) el.nameCount.textContent = state.name.length + '/' + config.nameMax;
        renderName();
      }
      syncLiveThumb();
    }
  };

  function boot(scope) {
    var roots = (scope || document).querySelectorAll('cp-tt-buybox');
    Array.prototype.forEach.call(roots, function (root) {
      Buybox.init(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  /* The theme editor replaces the section's markup wholesale, which drops
     every listener attached above. */
  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });

  /* The "choose" links in cp-tt-designs live in a different section, so this is
     delegated off the document rather than bound inside the buybox. The click
     is not cancelled — the anchor's own href does the scrolling, and this only
     moves the selection before the jump lands. */
  document.addEventListener('click', function (event) {
    var target = event.target;
    var link = target && target.closest ? target.closest('[data-cp-tt-pick]') : null;
    if (!link) return;

    var wanted = link.getAttribute('data-cp-tt-pick');
    var box = document.querySelector('cp-tt-buybox');
    if (!box || !wanted) return;

    var radios = box.querySelectorAll('[data-cp-tt="design"]');
    var hit = null;
    Array.prototype.forEach.call(radios, function (radio) {
      if (radio.value === wanted) hit = radio;
    });

    /* A scene whose value matches no design — or one that is sold out — just
       scrolls, rather than silently selecting the wrong thing. */
    if (!hit || hit.disabled) return;
    /* Already selected: a click still counts as choosing it, and reveals it. */
    if (hit.checked) {
      hit.click();
      return;
    }
    hit.checked = true;
    hit.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();
